/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 1xLhJbx5VveCXJsMYNxtFb
// Component: vEnSX2sF6UOQ
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  generateStateOnChangeProp,
  generateStateValueProp,
  hasVariant,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: 1xLhJbx5VveCXJsMYNxtFb/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic.module.css"; // plasmic-import: 1xLhJbx5VveCXJsMYNxtFb/projectcss
import sty from "./PlasmicTextarea.module.css"; // plasmic-import: vEnSX2sF6UOQ/css

createPlasmicElementProxy;

export const PlasmicTextarea__VariantProps = new Array(
  "fixedLayout",
  "flexibleLayout",
  "radius",
  "ststus"
);

export const PlasmicTextarea__ArgProps = new Array(
  "inputName",
  "required",
  "placeholder"
);

const $$ = {};

function PlasmicTextarea__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {
          required: false
        },
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "textarea2.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined
      },
      {
        path: "fixedLayout",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.fixedLayout
      },
      {
        path: "flexibleLayout",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.flexibleLayout
      },
      {
        path: "radius",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.radius
      },
      {
        path: "ststus",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.ststus
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  const styleTokensClassNames = _useStyleTokens();
  return (
    <textarea
      data-plasmic-name={"textarea2"}
      data-plasmic-override={overrides.textarea2}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.textarea,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.textarea2,
        {
          [sty.textarea2fixedLayout_medium]: hasVariant(
            $state,
            "fixedLayout",
            "medium"
          ),
          [sty.textarea2fixedLayout_small]: hasVariant(
            $state,
            "fixedLayout",
            "small"
          ),
          [sty.textarea2flexibleLayout_bigHeight]: hasVariant(
            $state,
            "flexibleLayout",
            "bigHeight"
          ),
          [sty.textarea2flexibleLayout_mediumHeight]: hasVariant(
            $state,
            "flexibleLayout",
            "mediumHeight"
          ),
          [sty.textarea2flexibleLayout_smallHeight]: hasVariant(
            $state,
            "flexibleLayout",
            "smallHeight"
          ),
          [sty.textarea2radius_halfModule]: hasVariant(
            $state,
            "radius",
            "halfModule"
          ),
          [sty.textarea2radius_one]: hasVariant($state, "radius", "one"),
          [sty.textarea2radius_two]: hasVariant($state, "radius", "two"),
          [sty.textarea2ststus_disabled]: hasVariant(
            $state,
            "ststus",
            "disabled"
          ),
          [sty.textarea2ststus_error]: hasVariant($state, "ststus", "error")
        }
      )}
      name={(() => {
        try {
          return $props.inputName;
        } catch (e) {
          if (
            e instanceof TypeError ||
            e?.plasmicType === "PlasmicUndefinedDataError"
          ) {
            return undefined;
          }
          throw e;
        }
      })()}
      onChange={async (...eventArgs) => {
        (e => {
          generateStateOnChangeProp($state, ["textarea2", "value"])(
            e.target.value
          );
        }).apply(null, eventArgs);
      }}
      placeholder={(() => {
        try {
          return $props.placeholder;
        } catch (e) {
          if (
            e instanceof TypeError ||
            e?.plasmicType === "PlasmicUndefinedDataError"
          ) {
            return undefined;
          }
          throw e;
        }
      })()}
      ref={ref => {
        $refs["textarea2"] = ref;
      }}
      required={(() => {
        try {
          return $props.required;
        } catch (e) {
          if (
            e instanceof TypeError ||
            e?.plasmicType === "PlasmicUndefinedDataError"
          ) {
            return undefined;
          }
          throw e;
        }
      })()}
      value={generateStateValueProp($state, ["textarea2", "value"]) ?? ""}
    />
  );
}

const PlasmicDescendants = {
  textarea2: ["textarea2"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicTextarea__ArgProps,
          internalVariantPropNames: PlasmicTextarea__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicTextarea__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "textarea2") {
    func.displayName = "PlasmicTextarea";
  } else {
    func.displayName = `PlasmicTextarea.${nodeName}`;
  }
  return func;
}

export const PlasmicTextarea = Object.assign(
  // Top-level PlasmicTextarea renders the root element
  makeNodeComponent("textarea2"),
  {
    // Helper components rendering sub-elements
    // Metadata about props expected for PlasmicTextarea
    internalVariantProps: PlasmicTextarea__VariantProps,
    internalArgProps: PlasmicTextarea__ArgProps
  }
);

export default PlasmicTextarea;
/* prettier-ignore-end */
